"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AffiliatedPointConversionInputSchema = exports.AffiliatedPointConvertResponseSchema = exports.AffiliatedPointBalanceResponseSchema = exports.AffiliatedPointValidationResponseSchema = exports.AffiliatedPointConnectResponseSchema = exports.AffiliatedPointConnectInputSchema = exports.AffiliatedPointInputSchema = exports.AffiliationMemberStatusCodeSchema = exports.AffiliatedPointErrorCode = exports.AffiliationMemberStatusCode = exports.AffiliatedPointCode = void 0;
var zod_1 = require("zod");
var member_1 = require("../member");
/**
 * 제휴포인트 코드
 *  현재는 CJONE 포인트만 있지만, 앞으로 추가될 예정
 * */
exports.AffiliatedPointCode = {
    CJ_ONE_POINT: 'CJONE',
    INTERPARK: 'INTERPARK',
    TRIPLE: 'TRIPLE',
};
/**
 * 제휴포인트 회원 상태 코드
 * */
exports.AffiliationMemberStatusCode = {
    /**
     * 제휴사 연결 회원
     * */
    CONNECT: 'CONNECT',
    /**
     * 제휴사 미연결 회원
     * */
    DISCONNECT: 'DISCONNECT',
    /**
     * 제휴사 미가입 회원
     * */
    NOT_JOIN: 'NOT_JOIN',
    /**
     * CI 미인증 회원
     * */
    NOT_CERTIFY: 'NOT_CERTIFY',
    /**
     * 제휴사 점검중
     * */
    INSPECT: 'INSPECT',
    /**
     * 알 수 없음 (통신 불가)
     * */
    UNKNOWN: 'UNKNOWN',
};
exports.AffiliatedPointErrorCode = {
    BAD_REQUEST: 'BAD_REQUEST',
    INTERNAL_SERVER_ERROR: 'INTERNAL_SERVER_ERROR',
    EXCHANGE_LIMIT_EXCEEDED: 'EXCHANGE_LIMIT_EXCEEDED',
    POINT_CONVERSION_FAIL: 'POINT_CONVERSION_FAIL',
    EXCHANGE_POINT_EMPTY: 'EXCHANGE_POINT_EMPTY',
    EXCHANGE_POINT_FAIL: 'EXCHANGE_POINT_FAIL',
    AFFILIATION_POINT_SERVICE_TERMINATE: 'AFFILIATION_POINT_SERVICE_TERMINATE',
    UNDER_14_YEARS_OLD_NOT_AVAILABLE: 'UNDER_14_YEARS_OLD_NOT_AVAILABLE',
};
exports.AffiliationMemberStatusCodeSchema = zod_1.z.enum([
    exports.AffiliationMemberStatusCode.CONNECT,
    exports.AffiliationMemberStatusCode.DISCONNECT,
    exports.AffiliationMemberStatusCode.NOT_JOIN,
    exports.AffiliationMemberStatusCode.NOT_CERTIFY,
    exports.AffiliationMemberStatusCode.INSPECT,
    exports.AffiliationMemberStatusCode.UNKNOWN,
]);
exports.AffiliatedPointInputSchema = zod_1.z.object({
    affiliationPointCode: zod_1.z.literal(exports.AffiliatedPointCode.CJ_ONE_POINT),
});
exports.AffiliatedPointConnectInputSchema = zod_1.z.object({
    affiliationPointCode: zod_1.z.literal(exports.AffiliatedPointCode.CJ_ONE_POINT),
    agreements: member_1.UpdateAgreementsInputSchema,
});
exports.AffiliatedPointConnectResponseSchema = zod_1.z.object({
    affiliationMemberStatusCode: exports.AffiliationMemberStatusCodeSchema,
    affiliationPointBalance: zod_1.z.number().nullable(),
    agreements: zod_1.z.boolean(),
});
exports.AffiliatedPointValidationResponseSchema = zod_1.z.object({
    affiliationMemberStatusCode: exports.AffiliationMemberStatusCodeSchema,
    totalBalance: zod_1.z.number().nullable(),
    exchangeableBalance: zod_1.z.number().nullable(),
});
exports.AffiliatedPointBalanceResponseSchema = exports.AffiliatedPointValidationResponseSchema.extend({
    affiliationMemberStatusCode: exports.AffiliationMemberStatusCodeSchema,
    affiliationPointBalance: zod_1.z.number().nullable(),
});
exports.AffiliatedPointConvertResponseSchema = zod_1.z.object({
    exchangeAmount: zod_1.z.number(),
});
exports.AffiliatedPointConversionInputSchema = exports.AffiliatedPointInputSchema.extend({ exchangeAmount: zod_1.z.number() });
